import React from 'react';
import { Sparkles } from 'lucide-react';
export function MicroTranceSection() {
  return <section className="w-full bg-gradient-to-b from-gray-900 to-gray-800 py-16 px-4" data-id="element-170">
      <div className="max-w-4xl mx-auto text-center" data-id="element-171">
        <div className="flex items-center justify-center mb-8" data-id="element-172">
          <Sparkles size={32} className="text-amber-500 mr-3" data-id="element-173" />
          <h2 className="text-3xl font-bold text-white" data-id="element-174">
            Guided Visualization
          </h2>
        </div>
        <div className="bg-gray-800 rounded-lg shadow-lg p-8 mb-10 border border-gray-700" data-id="element-175">
          <p className="text-xl text-gray-300 italic mb-6" data-id="element-176">Picture this...</p>
          <div className="space-y-6 text-left mb-8" data-id="element-177">
            <div className="p-4 border-l-4 border-amber-600 bg-gray-900" data-id="element-178">
              <p className="text-lg text-gray-300" data-id="element-179">
                You speak—and people listen. You post—and create movement. You
                show up—and lead naturally.
              </p>
            </div>
            <div className="p-4 border-l-4 border-amber-600 bg-gray-900" data-id="element-180">
              <p className="text-lg text-gray-300" data-id="element-181">
                Not because you pretend. But because you've mastered invisible
                principles. Strategies that work beneath the surface.
              </p>
            </div>
            <div className="p-4 border-l-4 border-amber-600 bg-gray-900" data-id="element-182">
              <p className="text-lg text-gray-300" data-id="element-183">
                Just like Charlie did. And just like you can.
              </p>
            </div>
          </div>
          <p className="text-xl font-semibold text-amber-400" data-id="element-184">
            This is not a fantasy. It's what thousands of leaders are already
            experiencing.
          </p>
        </div>
      </div>
    </section>;
}